import PageHeader from "../components/PageHeader";
import Projects from "../components/Projects";

function ProjectsPage() {
  return (
    <>
      <PageHeader
        crumb="Projects"
        eyebrow="Recent Work"
        title="Our Projects"
        lead="A glimpse of the products and tools we have designed, built and shipped for clients around the world."
      />
      <Projects />
    </>
  );
}

export default ProjectsPage;
